'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useSearchParameters } from '../../lib/hooks/useSearchParameters.js';
import { useCouponId } from '../hooks/useCouponId.js';
import { useCouponIndices } from '../hooks/useCouponIndices.js';
/**
 * Component that validates couponIndex in URL.
 *
 * @returns nothing
 */
export default function CouponIndexValidator() {
    const searchParams = useSearchParameters('coupon');
    const couponIndex = searchParams.coupon ?? 0;
    const pathname = usePathname();
    const router = useRouter();
    const params = useSearchParams();
    const [couponId] = useCouponId();
    const couponIndices = useCouponIndices({ couponId });
    const numberOfCoupons = couponIndices.length;
    const isValidCouponIndex = Number(couponIndex) + 1 <= numberOfCoupons;
    useEffect(() => {
        if (numberOfCoupons === 0 || isValidCouponIndex) {
            return undefined;
        }
        const qs = new URLSearchParams(params.toString());
        if (couponIndex && numberOfCoupons > 1) {
            qs.set('coupon', JSON.stringify(couponIndex - 1));
        }
        else {
            qs.delete('coupon');
        }
        const timeoutId = setTimeout(() => {
            router.replace(`${pathname}?${qs.toString()}`);
        }, 0);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [isValidCouponIndex, numberOfCoupons, params, pathname, router, couponIndex]);
    return undefined;
}
//# sourceMappingURL=CouponIndexValidator.js.map